import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { PHONE_SHELL_MAX_PX } from "../utility/phoneShell";

const PhoneShellContext = createContext(null);

const DEFAULTS = {
  enabled: false,
  boardQuery: "",
  setBoardQuery: () => {},
  searchOpen: false,
  setSearchOpen: () => {},
  allSportsOpen: false,
  setAllSportsOpen: () => {},
  entryOpen: false,
  setEntryOpen: () => {},
};

export function usePhoneViewport() {
  const query = `(max-width: ${PHONE_SHELL_MAX_PX}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    const sync = () => setMatches(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, [query]);

  return matches;
}

export function PhoneShellProvider({ enabled, children }) {
  const [boardQuery, setBoardQuery] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [allSportsOpen, setAllSportsOpen] = useState(false);
  const [entryOpen, setEntryOpen] = useState(false);

  const closeSheets = useCallback(() => {
    setAllSportsOpen(false);
    setEntryOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      enabled: Boolean(enabled),
      boardQuery,
      setBoardQuery,
      searchOpen,
      setSearchOpen,
      allSportsOpen,
      setAllSportsOpen,
      entryOpen,
      setEntryOpen,
      closeSheets,
    }),
    [enabled, boardQuery, searchOpen, allSportsOpen, entryOpen, closeSheets]
  );

  return <PhoneShellContext.Provider value={value}>{children}</PhoneShellContext.Provider>;
}

export function usePhoneShell() {
  return useContext(PhoneShellContext) || DEFAULTS;
}
